<template>
    <div class="con">
      <div class="banner">
          <img src="../assets/human.png" alt="">
          <div class="text animated fadeInUp">
              <p>{{$t('human').text1}}</p>
              <p>
                  {{$t('human').text2}}<br>
                  {{$t('human').text3}}<br>
                  {{$t('human').text4}}
              </p>
          </div>
          <div class="scr">
              <span>scrool</span>
              <span></span>
          </div>
      </div>
        <div class="main">
            <p class="title wow fadeInUp">  {{$t('human').text6}}</p>
            <div class="mainCon wow fadeInUp">
            <div class="item" v-for="(item,index) in list" :key="index" @click="showDia(item.ID)">
                <span>{{item.TITLE}}</span>
                <span><i class="iconfont add"></i>  {{$t('human').text5}}</span>
            </div>
            </div>
            <div style="text-align: center;" @click="showMore">
                <span>{{$t('about').text2}}</span>
                <btn-Component></btn-Component>
            </div>
        </div>
        <div class="dark" v-if="dialogVisible" @click="menuclose">
            <div id="dia" class="dd"></div>
            <dia-Component   :num="ID"   ></dia-Component>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import btnComponent from '../components/btn'
    import diaComponent from '../components/dialog'
    import Scrollbar from 'smooth-scrollbar';
    import { getNewsUrl} from '../util/lang'
    export default {
        name: "human",
        data(){
            return{
                ID:'',
                id:'',
                page:'',
                totalPage:'',
                dialogVisible:false,
                list:[]
            }
        },
        components:{footComponent,btnComponent,diaComponent},
        mounted(){
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            this.scrollbar.scrollTo(0,0)
            if( this.$i18n.locale === 'en'){
                this.getNews('35')
            }else{
                this.getNews('28')
            }
        },
        methods:{
            showDia(id){
                this.top=this.scrollbar.scrollTop
                this.dialogVisible=true
                this.ID=id
                setTimeout(()=>{
                    Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#dia"))
                },100)
            },
            showMore(){
                if(this.page<=this.totalPage){
                    this.$nextTick(()=>{
                        const url = `${getNewsUrl(this.$i18n.locale,this.id,6,this.page++)}`
                        this.$axios.get(url).then(res => {
                            this.list= this.list.concat(res.data.newsArr)
                        })

                    })
                }else{
                    this.$notify({
                        title: '提示',
                        message: '已经加载全部了',
                        offset: 100
                    });
                }
            },
            getNews(id){
                this.page=2
                this.id=id
                const url = `${getNewsUrl(this.$i18n.locale,id,6,1)}`
                this.$axios.get(url).then(res => {
                    this.list=res.data.newsArr
                    this.totalPage=res.data.pagerShow.totalPagers
                })
            },
            menuclose(){
                this.scrollbar.scrollTo(0,this.top)
                this.dialogVisible=false
            },
        }
    }
</script>

<style lang="scss" scoped>
    .dark{
        position: absolute;
        top:0;
        left: 0;
        width:100%;
        height:100%;
        background-color: rgba(0,0,0,.7);
        z-index: 0;
        .dd{
            margin-top: 800px;
            width:100%;
            height:10px;
            padding-top: 150px;
        }
    }
.con{
    width:100%;
    .banner{
        width:100%;
        position: relative;
        height:100vh;
        overflow: hidden;
        img{
            width:100%;
            height:100%;
            object-fit: cover;
            display: block;
        }
        .text{
            position: absolute;
            left:10%;
            width:70%;
            top:40%;
            color:white;
            p:nth-child(1){
                font-size: 50px;
                font-weight: bold;
            }
            p:nth-child(2){
                font-family: normal;
                font-weight: lighter;
                margin-top: 40px;
                line-height: 30px;
                font-size: 14px;
            }
        }
        .scr{
            width:10%;
            position: absolute;
            left:45%;
            bottom:0;
            z-index: 1000;
            height:120px;
            text-align: center;
            text-transform: uppercase;
            display: flex;
            flex-direction: column;
            justify-content: center;
            span:nth-child(1){
                color:white;
                padding-bottom: 10px;
                font-size: 12px;
            }
            span:nth-child(2){
                width:1px;
                height:100px;
                background-color: rgba(255,255,255,.2);
                position: relative;
                margin-left: 50%;
            }
            span:nth-child(2)::before{
                content:'';
                display: inline-block;
                width:1px;
                height:20px;
                position: absolute;
                top:30%;
                left:0;
                animation: runa 2s infinite ease;
                background-color: white;
            }
            @keyframes runa {
                from{
                    top:0;
                }
                to{
                    top:100%;
                }
            }
        }

    }
    .main{
        width:1280px;
        margin: 60px auto;
        .title{
            font-size: 30px;
            font-weight: bold;
            padding-bottom: 30px;
            border-bottom: 1px solid rgba(130, 130, 130, .3);
            position: relative;
            text-align: center;
            width:30%;
            margin-left: 35%;
        }
        .title::before{
            position: absolute;
            left:35%;
            bottom:0;
            content:'';
            display: inline-block;
            height:1px;
            width:30%;
            background-color: #3B95FF;
        }
        .mainCon{
            width:100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin: 60px auto;
            .item{
                width:28%;
                margin-left: 2%;
                background-color: #D1DBE4;
                margin-top: 30px;
                padding: 15px 10px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                font-size: 14px;
                cursor: pointer;
                transition: 600ms;
                span{
                    i{
                        padding-right: 10px;
                    }
                }
            }
            .item:hover{
                background-color: #3B95FF;
                color:white;
            }
        }
    }
    @media screen and (max-width:1279px){
        .banner{
            .text{
                width:90%;
                top:20%;
                left:5%;
                p:nth-child(1){
                    font-size: 30px;
                }
                p:nth-child(2){
                    font-size: 13px;
                }
            }
        }
        .main{
            width:95%;
            margin-left: 2.5%;
            .title{
                width:100%;
                margin-left: 0;
                font-size: 22px;
            }
            .mainCon{
                .item{
                    width:100%;
                }
            }
        }
    }
}
    @media screen and (max-width:1680px){
        .dark{
            .dd{
                margin-top: 400px;
            }
        }
    }
    @media screen and (max-width:450px){
        .dark{
            .dd{
                margin-top: 100px;
            }
        }
    }
</style>